import { makeStyles } from '@material-ui/core';
import { Checkbox, Fab, FormControlLabel, Tooltip, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PrintIcon from '@material-ui/icons/Print';
import { useSelector, useDispatch } from 'react-redux';
import { processParameters } from './reportDataProcessingHelper';
import CADDataByMonth from './CADDataByMonth';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import ReportsDialog from './ReportsDialog';
import { fetchReports } from 'reducers/ReportsReducer';
import { getAccessPermission } from 'reducers/PermissionsReducer';
import { checkReportPermission } from 'utils/functions';
import { Typography } from '@mui/material';
import DownloadCSV from './DownloadCSV';
import { ReportIdConst } from '../../enums/report.enum';

const useStyles = makeStyles(() => ({
  container: {
    height: '65vh',
    overflow: 'auto',
  },
  reportContainer: {
    display: 'flex',
  },
  reportSelection: {
    flex: 0.2,
  },
  reportFilter: {
    flex: 0.7,
  },
  report: {
    paddingBottom: '4px',
  },
  printSection: {
    flex: 0.1,
    textAlign: 'center',
    width: '100%',
  },
  fieldsetWrapper: {
    padding: '25px 10px 10px',
    width: '92%',
    height: '50vh',
  },

  fieldsetWrapperFilter: {
    padding: '15px 13px 5px',
    marginTop: '6px',
    height: '50vh',
    width: '100%',
  },
  fieldsetWrapperBorder: {
    border: '2px solid',
    borderColor: '#1e8dfa',
    borderRadius: '10px',
  },
  fieldsetTitleFilter: {
    position: 'absolute',
    marginTop: '-25px',
    padding: '2px 10px',
  },
  fieldsetTitleBackground: {
    color: 'white',
    background: '#1e8dfa',
    borderRadius: '10px',
  },
}));
function TopbarReportSection(props) {
  const classes = useStyles();
  const [checkedReportList, setCheckedReportList] = useState({});
  const [reportForm, setReportForm] = useState({});
  const [filteredList, setFileredList] = useState([]);
  const [filteredReportList, setFilteredReportList] = useState([]);
  const [isValid, setIsValid] = useState(true);
  const reportingOfficer = useSelector((state) => state.user?.userData?.user?.FullName);

  const [showPrint, setShowPrint] = useState(false);
  const [currentReportData, setCurrentReportData] = useState(null);
  const dispatch = useDispatch();
  const reportList = useSelector((state) => state.reports?.data?.data ?? []);

  useEffect(() => {
    dispatch(fetchReports());
  }, [dispatch]);

  useEffect(() => {
    const newList = filteredReportList.filter(
      (item) => checkedReportList[item.ReportID] && checkReportPermission(item.ReportID)
    );
    setFileredList(newList);
  }, [filteredReportList, checkedReportList]);

  useEffect(() => {
    const newList = reportList.filter((item) => {
      const permission = getAccessPermission('report', item.ReportID, 'any');
      return permission ? true : false;
    });
    setFilteredReportList(newList);
  }, [reportList]);

  useEffect(() => {
    const has314 = filteredList.some((item) => item.ReportID === 314 || item.ReportID === '314');
    const agency314 = reportForm?.[314]?.agency || reportForm?.['314']?.agency;
    if (has314 && !agency314) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, [filteredList, reportForm]);

  const handleReportSelection = (item) => {
    const newFormData = { ...reportForm };
    if (checkedReportList[item.ReportID]) {
      const newList = { ...checkedReportList };
      delete newList[item.ReportID];
      setCheckedReportList(newList);

      delete newFormData[item.ReportID];
      setReportForm({ ...newFormData });
    } else {
      setCheckedReportList({
        ...checkedReportList,
        [item.ReportID]: true,
      });

      newFormData[item.ReportID] = {};
      setReportForm({ ...newFormData });
    }
  };

  const handleReportFormChange = (ReportID, filedName, value, multipleValue) => {
    let newForm = { ...reportForm };
    newForm[ReportID] = newForm[ReportID] ? { ...newForm[ReportID] } : {};
    if (multipleValue) {
      newForm[ReportID] = { ...newForm[ReportID], [filedName]: value, ...multipleValue };
    } else {
      newForm[ReportID] = { ...newForm[ReportID], [filedName]: value };
    }
    setReportForm({ ...newForm });
  };

  const hanldePrintButtonClick = (arr = []) => {
    if (arr.length > 0) {
      const id = arr[0];
      const processedData = processParameters(id, reportForm[id]);
      const data = { ...processedData, ReportingOfficer: reportingOfficer };
      if (data) {
        setCurrentReportData({ id, data, reportList: arr });
        setShowPrint(true);
      }
    }
  };

  const onPrintDialogClose = (id, arr) => {
    const newArr = arr.filter((item) => item !== id);
    setShowPrint(false);
    if (newArr.length > 0) hanldePrintButtonClick(newArr);
  };
  return (
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs={4} md={3}>
        <div
          className={clsx(
            classes.fieldsetWrapperBorder,
            classes.fieldsetWrapperFilter,
            classes.container
          )}>
          <div className={clsx(classes.fieldsetTitleFilter, classes.fieldsetTitleBackground)}>
            Select Reports
          </div>
          {filteredReportList.length > 0 ? (
            filteredReportList.map((item) => (
              <FormControlLabel
                style={{ display: 'block' }}
                control={
                  <Checkbox
                    key={item.ReportID}
                    checked={checkedReportList[item.ReportID] || false}
                    onChange={() => handleReportSelection(item)}
                    name={item.ReportID}
                  />
                }
                label={item.ReportTitle}
              />
            ))
          ) : (
            <div style={{ padding: '8px 16px', color: '#777' }}>
              You don’t have permission to view any reports.
            </div>
          )}
        </div>
      </Grid>
      <Grid item xs={7} md={8}>
        <div
          className={clsx(
            classes.fieldsetWrapperBorder,
            classes.fieldsetWrapperFilter,
            classes.container
          )}>
          <div className={clsx(classes.fieldsetTitleFilter, classes.fieldsetTitleBackground)}>
            Filters
          </div>
          {filteredList.map((item) => {
            let FilterComponent = null;
            switch (item.ReportID) {
              case ReportIdConst.CADDataByMonth:
                FilterComponent = CADDataByMonth;
                break;
              default:
                break;
            }

            return (
              <div>
                <Grid container alignItems="center">
                  <Grid item xs>
                    <Typography variant="subtitle1" className="py-2">
                      {item.ReportTitle}
                    </Typography>
                  </Grid>

                  <Grid item>
                    <DownloadCSV
                      ReportID={item.ReportID}
                      filters={processParameters(item.ReportID, reportForm[item.ReportID], 'csv')}
                    />
                  </Grid>
                </Grid>

                {FilterComponent && (
                  <FilterComponent
                    reportForm={reportForm}
                    handleReportFormChange={handleReportFormChange}
                    ReportID={item.ReportID}
                    title={item.ReportTitle}
                  />
                )}
              </div>
            );
          })}
        </div>
      </Grid>

      <Grid item xs={1}>
        <div style={{ position: 'absolute', right: 0, display: 'flex', gap: '10px' }}>
          <Tooltip>
            <Fab
              disabled={Object.keys(reportForm).length < 1 || !isValid}
              size="small"
              color="primary"
              onClick={() => {
                const ids = Object.keys(reportForm);
                hanldePrintButtonClick(ids);
              }}>
              <PrintIcon />
            </Fab>
          </Tooltip>
          <Tooltip>
            <Fab size="small" color="primary" onClick={() => props.setReportsMenuVisible(false)}>
              <CloseIcon />
            </Fab>
          </Tooltip>
        </div>
      </Grid>
      {showPrint && (
        <ReportsDialog
          open={showPrint}
          setShowPrint={setShowPrint}
          onClose={onPrintDialogClose}
          report={currentReportData}
        />
      )}
    </Grid>
  );
}

export default TopbarReportSection;
